<script lang="ts">
import { siFacebook } from "simple-icons";
import SimpleIcon from "./SimpleIcon.svelte";

let { class: className }: { class?: string } = $props();
</script>

<SimpleIcon icon={siFacebook} class={className} />
